// extracted by mini-css-extract-plugin
module.exports = {"content":"Layout_content__2eknG","wrapper":"Layout_wrapper__2wx5I"};